import { render, staticRenderFns } from "./AppNotificationBanner.vue?vue&type=template&id=15760d6a&scoped=true&"
import script from "./AppNotificationBanner.vue?vue&type=script&lang=js&"
export * from "./AppNotificationBanner.vue?vue&type=script&lang=js&"
import style0 from "./AppNotificationBanner.vue?vue&type=style&index=0&id=15760d6a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15760d6a",
  null
  
)

export default component.exports